import styled from 'styled-components';

export const StyledBreadcrumbs = styled.div`
  display: flex;
  height: ${props => props.theme.spacing(12)};
  width: 100%;
  background-color: ${props => props.theme.colors.background.base};
`;

export const BreadcrumbsContainer = styled.div`
  display: flex;
  margin-left: ${props => props.theme.spacing(8)};
  align-items: center;
  justify-content: center;
`;
